export class AdministrativeUnit {
    code: string = '';
    name: string = '';
    full_name: string = '';
    normalized_value: string = '';


    constructor(data?: Partial<AdministrativeUnit>) {
        Object.assign(this, data);
    }
}
